import { type NavigateFunction } from 'react-router-dom';

const clearLocationHistory = (navigate: NavigateFunction) => {
  navigate({}, { replace: true, state: undefined });
};

export default clearLocationHistory;
